import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useAuthStore } from '@/store/auth'

// 创建axios实例
const service = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const authStore = useAuthStore()
    if (authStore.token) {
      config.headers.Authorization = `Bearer ${authStore.token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    // 统一响应格式处理
    if (res.status !== undefined) {
      if (res.status === 0) {
        // 成功响应，直接返回完整的响应结构
        // 包含：status, message, data, meta
        return res
      } else {
        // 错误响应
        ElMessage.error(res.message || '请求失败')
        return Promise.reject(new Error(res.message || '请求失败'))
      }
    }

    // 向后兼容：如果没有status字段，使用旧格式处理
    if (res.success !== undefined) {
      if (res.success) {
        return {
          status: 0,
          message: res.message || 'Success',
          data: res.data
        }
      } else {
        ElMessage.error(res.error || res.message || '请求失败')
        return Promise.reject(new Error(res.error || res.message || '请求失败'))
      }
    }

    // 最后的兼容：直接返回数据，包装成统一格式
    return {
      status: 0,
      message: 'Success',
      data: res
    }
  },
  error => {
    console.error('API Error:', error)

    const { response } = error

    if (response) {
      switch (response.status) {
        case 401:
          ElMessage.error('认证失败，请重新登录')
          // 清除token并跳转到登录页
          const authStore = useAuthStore()
          authStore.logout()
          window.location.href = '/login'
          break
        case 403:
          ElMessage.error('没有权限访问该资源')
          break
        case 404:
          ElMessage.error('请求的资源不存在')
          break
        case 500:
          ElMessage.error('服务器内部错误')
          break
        default:
          ElMessage.error(response.data?.message || '网络错误')
      }
    } else {
      ElMessage.error('网络连接失败，请检查网络')
    }

    return Promise.reject(error)
  }
)

export default service
